// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"99dc4378","845":"6aeace5f"}[chunkId] + ".chunk.js";
};